<template>
    <div>
        <v-container fluid>
            <v-row no-gutters>
                <v-col :cols="6">
                    <h1 class="headline font-weight-light mb-3">
                        View {{ $route.params.subproject }} Case
                    </h1>
                </v-col>
                <v-col :cols="6" class></v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-btn
                        color="grey darken-1"
                        dark
                        fab
                        small
                        class="elevation-4"
                        :to="'/Project/PmInstall/' + $route.params.project"
                    >
                        <v-icon>mdi-reply</v-icon>
                    </v-btn>
                </v-col>

                <v-btn
                    @click="dialog = true"
                    class="ma-2"
                    tile
                    outlined
                    color="success"
                >
                    <v-icon left>mdi-plus</v-icon>Add Case
                </v-btn>
            </v-row>
        </v-container>
        <v-row>
            <v-col
                v-for="(item, index) in arr_card"
                :key="index"
                :md="3"
                :sm="4"
            >
                <base-material-stats-card
                    v-on:onClick="selectCard(item.text)"
                    :color="item.color"
                    :icon="item.icon"
                    :title="item.project"
                    :value="item.num"
                    sub-icon="mdi-clock"
                    sub-text="Just Updated"
                />
            </v-col>
        </v-row>
        <v-card>
            <v-card-title>
                <v-row>
                    <v-col cols="12" sm="6" md="4">
                        <v-select
                            class="mr-2"
                            :items="status"
                            v-model="form.status"
                            item-text="main_status_name"
                            item-value="main_status_id"
                            label="Select Status"
                            multiple
                            clearable
                            @blur="test()"
                        >
                            <template v-slot:selection="{ item, index }">
                                <v-chip v-if="index < 2">
                                    <span>{{ item.main_status_name }}</span>
                                </v-chip>
                                <span
                                    v-if="index === 2"
                                    class="grey--text caption"
                                >
                                    (+{{ form.status.length - 2 }}
                                    others)
                                </span>
                            </template>
                        </v-select>
                    </v-col>

                    <v-col cols="12" sm="5" md="4">
                        <v-text-field
                            v-model="form.searchtext"
                            append-icon="mdi-magnify"
                            label="Search"
                            clearable
                            @input="
                                pagination.current = 1
                                getDetail()
                            "
                        ></v-text-field>
                    </v-col>
                </v-row>
            </v-card-title>

            <table-view-case :condition="condition" :data_case="data_case" />
            <div class="text-center pa-5">
                <v-pagination
                    @input="onPageChange"
                    v-model="pagination.current"
                    :length="data_case.last_page"
                    total-visible="10"
                    circle
                ></v-pagination>
            </div>
        </v-card>
    </div>
</template>

<script>
import axios from "axios"

import { mapState, mapMutations } from "vuex"

import TableViewCase from "../components/TableViewCase"
import MaterialStatsCard from "../../../components/StatsCard"

export default {
    components: {
        "table-view-case": TableViewCase,
        "base-material-stats-card": MaterialStatsCard,
    },
    computed: {
        ...mapState(["isLoading"]),
    },
    beforeMount() {
        this.tk = {
            headers: { Authorization: "Bearer " + localStorage.token },
        }
    },
    mounted() {
        this.getDetail()
        this.getProject()
        this.getSummary()
    },
    data() {
        return {
            tk: null,
            no: 1,
            data: [],
            condition: {
                team: "Nonhp",
                status: "ViewDetail",
            },
            search: "",
            url: process.env.VUE_APP_ROOT_API,
            data_case: [],
            form: {
                projects: [],
                status: [],
                searchtext: "",
            },
            projects: [],
            status: [],
            pagination: {
                current: 1,
            },
            data_summary: [],
            arr_card: [
                {
                    project: "Pending",
                    text: "pending",
                    color: "yellow lighten-1",
                    icon: "#",
                    num: "",
                },
                {
                    project: "Complete",
                    text: "complete",
                    color: "red accent-2",
                    icon: "#",
                    num: "",
                },
            ],
        }
    },
    methods: {
        ...mapMutations(["mutateIsLoading"]),
        test() {
            this.getDetail()
        },
        async getSummary() {
            const url = `${process.env.VUE_APP_ROOT_API}/api/nonhp/group/${this.$route.params.project}`
            try {
                const { data } = await axios.get(`${url}`, this.tk)
                data.map((each) => {
                    if (each.group_id == this.$route.params.groupid) {
                        this.arr_card.map((res, index1) => {
                            switch (res.text) {
                                case "pending":
                                    this.arr_card[index1].num = each.total
                                    break
                                case "complete":
                                    this.arr_card[index1].num =
                                        each.total - each.pending
                                    break
                            }
                        })
                    }
                })
            } catch (error) {
                console.log(error)
            }
        },
        getDetail: _.debounce(async function(e) {
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            const url = `${process.env.VUE_APP_ROOT_API}/api/nonhp/view-group-case/${this.$route.params.groupid}?page=${this.pagination.current}`
            try {
                this.mutateIsLoading()
                const { data } = await axios.post(`${url}`, this.form, options)
                this.pagination.current = data.current_page
                this.data_case = data
                this.mutateIsLoading()
            } catch (error) {
                console.log(error)
            }
        }, 1000),
        onPageChange() {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth",
            })
            this.getDetail()
        },
        selectCard(params) {
            Object.values(this.data_summary).map((each) => {
                if (params == each.title) {
                    this.form.status = [...each.filter]
                }
            })
            this.pagination.current = 1
            this.getDetail()
        },
        async getProject() {
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            const url = `${process.env.VUE_APP_ROOT_API}/api/filtercase`
            try {
                const { data } = await axios.get(`${url}`, options)
                this.projects = data.projects
                this.status = data.main_status
            } catch (error) {}
        },
    },
}
</script>
